import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

class Animate extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    show: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    show: false,
    className: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,
      animationCss: '',
    };
  }

  componentDidUpdate = (prevProps) => {
    const { show } = this.props;

    if (!_.isEqual(this.props.show, prevProps.show)) {
      if (show) {
        this.setState(() => ({ show: true }));
        setTimeout(() => {
          this.setState(() => ({ animationCss: styles.animateExpand }));
        }, 100);
      } else {
        this.setState(() => ({ animationCss: '' }));
        setTimeout(() => {
          this.setState(() => ({ show: false }));
        }, 400);
      }
    }
  }

  render = () => {
    const { children, className } = this.props;
    const { show, animationCss } = this.state;

    return (
      <div className={`${styles.animatedElement} ${animationCss} ${className}`}>
        { show && children}
      </div>
    );
  }
}

export default Animate;
